import { AuthUserPermission, usePermissions } from '@cibo/profile'
import { DrawField } from 'components/DrawField'
import { LAND_MANAGER_ROUTES } from 'navigation/types/routes'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'
import { BreadcrumbNavigation } from '../../../components/ImpactLayout'

export const LandManagerDrawFields = () => {
  const { t } = useTranslation('impact/pages/LandManager')
  const navigate = useNavigate()
  const { can } = usePermissions()

  const handleCancel = useCallback(() => {
    navigate(LAND_MANAGER_ROUTES.ROOT)
  }, [])
  const handleComplete = useCallback(({ field: { resourceId } }) => {
    if (can({ useAny: AuthUserPermission.FIELD_VIEW_DETAIL_REPORT })) {
      navigate(generatePath(LAND_MANAGER_ROUTES.DETAIL, { resourceId }))
    } else {
      navigate(LAND_MANAGER_ROUTES.ROOT)
    }
  }, [])
  const handleProfile = useCallback(({ resourceIds }: { resourceIds: string[] }) => {
    navigate(LAND_MANAGER_ROUTES.PROFILE_FIELDS, { state: { profileFieldIds: resourceIds } })
  }, [])
  const handleCreateEnrollment = useCallback(() => {
    navigate(LAND_MANAGER_ROUTES.ROOT)
  }, [])

  return (
    <>
      <BreadcrumbNavigation
        breadcrumbs={[
          {
            name: t('Fields'),
            to: LAND_MANAGER_ROUTES.ROOT,
          },
          {
            name: t('addFields'),
          },
        ]}
      />
      <DrawField
        onComplete={handleComplete}
        onCreateEnrollment={handleCreateEnrollment}
        onCancel={handleCancel}
        onProfile={handleProfile}
      />
    </>
  )
}
